// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".right[data-v-3d5d5def]{text-align:right}.center[data-v-3d5d5def],.centered-input[data-v-3d5d5def] input{text-align:center}", ""]);
// Exports
module.exports = exports;
